"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* -------------------------------------------------------------------------

	PUNITED.common

	サイト内で共通のスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.common) PUNITED.common = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.common;
  ns.mediaQuery = matchMedia('(max-width: 679px)');
  ns.touchQuery = window.matchMedia('(pointer: coarse)');
  ns.body = document.querySelector('body');
  ns.header = document.querySelector('.site_header');
  ns.classes = {
    current: '--current',
    open: '--open',
    pcOpen: '--pc_open',
    spOpen: '--sp_open',
    noScroll: '--no_scroll',
    sticky: '--sticky'
  };
  /* -----------------------------------------------------
  	IEの場合にメッセージを表示
  ----------------------------------------------------- */

  var userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('trident') != -1 || userAgent.indexOf('msie') != -1) {
    $("html").addClass("regacy_ie");
  }

  ns.handleScrollbarSize = function () {
    setScrollbarWidth();
    window.addEventListener('resize', setScrollbarWidth);

    function setScrollbarWidth() {
      var width = PUNITED.utils.getScrollbarWidth();
      var prop = "".concat(width, "px");
      document.documentElement.style.setProperty('--scrollbar--width', prop);
    }
  };

  ns.handlePhoneLink = function () {
    var links = document.querySelectorAll('a[href^="tel:"]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!ns.mediaQuery.matches) {
          e.preventDefault();
        }
      });
    });
  };

  ns.handleSpHeaderScroll = function () {
    var lastScrolled;
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });

    function handleScroll() {
      if (!ns.mediaQuery) {
        return;
      }

      var scrolled = getScrolled();

      if (scrolled === lastScrolled) {
        return;
      }

      lastScrolled = scrolled;
      ns.header.classList.toggle('--sp_scrolled', scrolled);
    }

    function getScrolled() {
      return window.scrollY >= 60;
    }
  };

  ns.handleCorpPcHeaderNav = function () {
    if (!ns.header) {
      return;
    }

    var container = ns.header.querySelector('.site_header__nav_row');
    var groups = ns.header.querySelectorAll('.site_header__nav_group.--has_children');
    var inTl = null;
    var outTl = null;
    ns.mediaQuery.addEventListener("change", function (e) {
      container.classList.remove(ns.classes.pcOpen);
      groups.forEach(function (group) {
        group.classList.remove(ns.classes.pcOpen);
        var body = group.querySelector('.site_header__nav_group_body');
        body.style.height = '';
        body.style.opacity = '';
      });
    });
    initListeners(ns.touchQuery.matches);
    ns.touchQuery.addEventListener('change', function (e) {
      initListeners(e.matches);
    });

    function initListeners(isTouch) {
      groups.forEach(function (group) {
        group.removeEventListener('pointerenter', handlePointer);
        group.removeEventListener('pointerleave', handlePointer);

        if (!isTouch) {
          group.addEventListener('pointerenter', handlePointer);
          group.addEventListener('pointerleave', handlePointer);
        }

        var toggles = group.querySelectorAll(".site_header__nav_group_title");
        toggles.forEach(function (toggle) {
          toggle.removeEventListener('click', handleClick);
          window.removeEventListener('click', handleClickOutside);

          if (isTouch) {
            toggle.addEventListener('click', handleClick);
            window.addEventListener('click', handleClickOutside);
          }
        });
      });
    }

    function handlePointer(e) {
      if (ns.mediaQuery.matches) {
        return;
      }

      handleToggle(e.target, e.type === 'pointerenter');
    }

    function handleClick(e) {
      if (ns.mediaQuery.matches) {
        return;
      }

      e.preventDefault();
      var currentGroup = e.currentTarget.closest('.site_header__nav_group');
      handleToggle(currentGroup, undefined, false);
    }

    function handleClickOutside(e) {
      groups.forEach(function (group) {
        if (!group.classList.contains(ns.classes.pcOpen) || group.contains(e.target)) {
          return;
        }

        handleToggle(group, false, false);
      });
    }

    function handleToggle(currentGroup, open) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var autoCloseOthers = open === undefined;
      open = currentGroup.classList.toggle(ns.classes.pcOpen, open);
      container.classList.toggle(ns.classes.pcOpen, open);
      var fade = false;

      if (inTl && inTl.progress() !== 1) {
        inTl.pause().progress(0).kill();
        inTl = null;
      }

      if (outTl && outTl.progress() !== 1) {
        outTl.pause().progress(1).kill();
        outTl = null;
        fade = open;
      }

      groups.forEach(function (group) {
        if (open && group.isSameNode(currentGroup)) {
          return;
        }

        var isOpen = group.classList.contains(ns.classes.pcOpen);
        group.classList.remove(ns.classes.pcOpen);

        if (isOpen && autoCloseOthers) {
          fade = true;
          toggleGroup(group, false, fade);
        }
      });
      toggleGroup(currentGroup, open, fade, delay);
    }

    function toggleGroup(group, open) {
      var fade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var body = group.querySelector('.site_header__nav_group_body');
      var content = body.querySelector('.site_header__nav_group_content');
      var height = content.offsetHeight;

      if (open) {
        inTl = gsap.timeline({
          defaults: {
            ease: CustomEase.create("custom", ".16, 1, .3, 1")
          },
          delay: delay ? .2 : 0
        });

        if (fade) {
          inTl.delay(0).set(body, {
            height: height,
            opacity: 1
          });
        } else {
          inTl.fromTo(body, {
            height: 0,
            opacity: 1
          }, {
            height: height,
            opacity: 1
          });
        }
      } else {
        if (body.offsetHeight > 0) {
          outTl = gsap.timeline({
            defaults: {
              ease: CustomEase.create("custom", ".16, 1, .3, 1")
            },
            delay: delay ? .2 : 0
          });

          if (fade) {
            outTl.delay(0).to(body, {
              height: 0,
              opacity: 0
            });
          } else {
            outTl.to(body, {
              height: 0
            });
          }
        }
      }
    }
  };

  ns.handleLangNav = function () {
    if (!ns.header) {
      return;
    }

    var lang = ns.header.querySelector('.site_header__lang');

    if (!lang) {
      return;
    }

    var head = ns.header.querySelector('.site_header__lang_head');
    var body = ns.header.querySelector('.site_header__lang_body');
    var list = ns.header.querySelector('.site_header__lang_list');
    lang.addEventListener('pointerenter', handlePointerToggle);
    lang.addEventListener('pointerleave', handlePointerToggle);
    head.addEventListener('click', handleClick);

    function handleClick(e) {
      if (!(ns.mediaQuery.matches || ns.touchQuery.matches)) {
        return;
      }

      handleToggle(e);
    }

    function handlePointerToggle(e) {
      if (ns.mediaQuery.matches || ns.touchQuery.matches) {
        return;
      }

      handleToggle(e);
    }

    function handleToggle(e) {
      // if (ns.mediaQuery.matches) {
      // 	return;
      // }
      e.preventDefault();
      var open = !lang.classList.contains(ns.classes.pcOpen);
      toggleGroup(lang, open);
    }

    function toggleGroup(group, open) {
      var customOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      group.classList.toggle(ns.classes.pcOpen, open);
      var height = list.offsetHeight;
      var bodyAnimations = body.getAnimations();
      bodyAnimations.forEach(function (animation) {
        animation.finish();
      });

      var options = _objectSpread({
        fill: 'both',
        duration: 600,
        easing: 'cubic-bezier(.16, 1, .3, 1)'
      }, customOptions);

      if (open) {
        body.animate([{
          height: 0
        }, {
          height: "".concat(height, "px")
        }], options);
      } else {
        body.animate([{
          height: "".concat(height, "px")
        }, {
          height: 0
        }], options);
      }
    }
  };

  ns.handleHeaderSpNavToggle = function () {
    if (!ns.header) {
      return;
    }

    var toggle = ns.header.querySelector('[class*="__sp_btn"]');
    toggle.addEventListener('click', function () {
      var open = ns.header.classList.toggle(ns.classes.spOpen);
      ns.body.classList.toggle(ns.classes.noScroll, open);
    });
    ns.mediaQuery.addEventListener("change", function (e) {
      if (!ns.header.classList.contains(ns.classes.spOpen)) {
        return;
      }

      ns.body.classList.toggle(ns.classes.noScroll, e.matches);
    });
  };

  ns.handleSpNav = function (prefix) {
    var preOpenCurrentSp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var groups = document.querySelectorAll(".".concat(prefix, "__nav_group.--has_children"));
    groups.forEach(function (group) {
      var toggle = group.querySelector(".".concat(prefix, "__nav_group_title"));
      toggle.addEventListener('click', function (e) {
        if (!ns.mediaQuery.matches) {
          return;
        }

        e.preventDefault();
        group.classList.toggle(ns.classes.spOpen);
      });
    });
  };
})();

$(function () {
  PUNITED.common.handleScrollbarSize();
  PUNITED.common.handlePhoneLink();
  PUNITED.common.handleSpHeaderScroll();
  PUNITED.common.handleCorpPcHeaderNav();
  PUNITED.common.handleLangNav();
  PUNITED.common.handleHeaderSpNavToggle();
  PUNITED.common.handleSpNav('site_header');
  PUNITED.common.handleSpNav('site_footer');
});